export default {
  "title": "FreeDive Ai",
  "heroHeadline": "हर दिन प्रशिक्षण लें और अपने फ्रीडाइविंग कौशल में सुधार करें!",
  "heroSubheadline": "फ्रीडाइवर्स, स्पीयरफिशर्स और मरमेड्स के लिए अंतिम AI एपनिया ट्रेनिंग ऐप।",
  "featuresHeader": "FreeDive Ai क्यों चुनें?",
  "featuresSubtitle": "गहरे गोता लगाने, अपनी सांस अधिक समय तक रोकने और सुरक्षित रहने के लिए आपको जो कुछ भी चाहिए।",
  "feature1Title": "AI एपनिया ट्रेनिंग",
  "feature1Desc": "सुरक्षित रूप से अपनी सांस रोकने का समय बढ़ाने के लिए आपके व्यक्तिगत सर्वश्रेष्ठ के आधार पर AI द्वारा उत्पन्न अनुकूलित CO2 और O2 टेबल।",
  "feature2Title": "स्मार्ट लॉगबुक",
  "feature2Desc": "अपने फ्रीडाइविंग और स्पीयरफिशिंग सत्र लॉग करें। गहराई, समय, हृदय गति और SpO2 सब एक ही जगह पर ट्रैक करें।",
  "feature3Title": "प्रतियोगिताएं और लाइसेंस",
  "feature3Desc": "अपने फ्रीडाइविंग लाइसेंस का ट्रैक रखें और वैश्विक प्रतियोगिताओं और घटनाओं के साथ अपडेट रहें।",
  "screenshotsTitle": "ऐप स्क्रीनशॉट",
  "copyright": "© DomiLabs. All rights reserved."
};
